import api from './apiHelper';

export const getCSV = (csvType, query) => api.get(`/${csvType}/csv`, {params: query});